/**
 * 所有使用的cmd应该统计到该类上
 * @author zhudc
 * @date 2020-05-29
 */

// 调用客户端cmd=webview_goback，客户端需要监听该事件有返回记录直接返回，没有返回记录关闭webview
export const GOBACK = 'webview_goback'

export const WEBVIEW_GOBACK = 'webview_goback'

// 该接口供js调用native的当前课文暂停播放功能，相当于点击了播放控制条中的暂停按钮。如果此时课文主音频尚未开始播放，则不做任何处理；如果此时处于播放状态，则暂停主音频的播放。
export const PLAYBACK_SUPPRESS = 'playback_suppress'

// 当用户点击富媒体播放时，webview告诉客户端已经播放
export const RICH_MEDIA_DID_PLAY = 'rich_media_did_play'

// 用户登录
export const USER_LOGIN = 'user_login'

// 打开外部浏览器
export const OPEN_URL = 'open_url'

// 透传统计
export const MOBCLICK = 'mobclick'

// 消息通知
export const ENABLED_notication = 'enabled&feat=notication'

export const LOCATION_ACCOUNT_CENTER = 'location_account_center'

export const LOCATION_FEEDBACK = 'location_feedback'

export const SAVE_IMAGE = 'save_image' // 保存图片

export const SAVE_BASE64_IMAGE = 'save_base64_image' // 保存base64图片

export const TAG_CHANGED = 'tag_changed' // 偏好设置标签改变

export const ALI_PAY = 'alipay' // 支付宝购买

export const IAP_PAY = 'iap' // 支付宝购买

export const QUERY_IAP = 'query_iap' // 判断是否iap支付

export const PAYCOIN = 'paycoin' // 酷币支付、iap支付

export const COINPAYED = 'coinpayed' // 酷币支付成功

export const CLOSE_VIEW = 'close_view' // 关闭当前webview页面

export const CHECK_INSTALLED = 'checkInstalled' // 检查是否安装微信 参数app=wechat，目前只有轻听支持

export const POP_WORD = 'pop_word' // 查词并且弹出

export const HIDE_POP_WORD = 'hide_pop_word' // 查词并且弹出

export const SHARE = 'share' //import android版本4.3位置 Android分享文字platform=wechattype=text&text=xxx而iOS分享文字是platform=wechattype=text&title=xxx，Android版qq不能分享纯文本

export const CALENDAR = 'calendar' //日历提醒,废弃

export const CALENDARS = 'calendars' //日历提醒 ex:`cmd=calendars&events=${encodeEvents}&id=${this.calendarsBody.event_id}`; 回调函数 window.action.calendars = (state)=>{}

export const ENABLE = 'enable' // 设置权限`cmd=enable&feat=${type}` type:microphone photos notification 回调函数 window.action.set_permissions = (feat,state)=>{}//state:1 开通成功

export const QUERY_ENABLE = 'query_enabled' // 查询权限`cmd=enable&feat=${type}` type:microphone photos notification window.action.query_permissions = (feat,state)=>{}//state:1 已成功

export const PERMISSIONS_PHOTOS = 'photos' //photos权限  接受回调方法window.action.query_permissions = (feat,state)=>{}//state:1 已成功

export const QUERY_USER_NETTYPE = 'query_user_nettype' // 查询网络类型

export const QUERY_USER_NETISP = 'query_user_netisp' // 查询网络运营商

export const FIXED_BUTTON_INFO = 'fixed_button_info' // 底部按钮信息主要用于传递给客户端使用titlexxx&info=xxx&url=xxx

export const USER_INFO_CHANGED = 'user_info_changed' // 用户信息改变通知客户端需要刷新用户信息

// cmd=clipboard&text=${encodeURIComponent('复制的内容');// 复制 仅安卓有该方法
// WebviewActionUtil.clipboardCallback(() => {});

export function callK9Bridge(cmd, params = {}) {
  const message = {
    cmd: cmd,
    params: params,
  }

  console.log('callK9Bridge', message);

  if ((window as any).K9Bridge && (window as any).K9Bridge.postMessage) {
    ; (window as any).K9Bridge.postMessage(JSON.stringify(message))
  }
}
/**
 * 推荐执行客户端指令
 * @param {String} cmd
 * @param {Object} obj
 * @returns {Promise}
 */
export const executeCmdParam = callK9Bridge
